

if($("[data-section-type=header][data-type=v2]").length) {
  $(document).ready(init);
}

function init(){

  //tier 1
  $(".mobile-menu .navigation__item-big.big-dropdown").on({
            click: function() {
                $(this).find(".navigation__tier-2").addClass("toggled");
                $(".mobile-menu").find(".dropdown").attr("data-opened", "false");
                $('#main-nav').animate({
                    scrollTop: 0
                }, 100);
            }
  }).children(".navigation__tier-2").click(function(e) {
    e.stopPropagation();
  });

  //tier 2
  $(".navigation__tier-2 .navigation__item").not(".dropdown").on({
            click: function() {
                $(this).find(".navigation__tier-3").addClass("toggled");
                $('#main-nav').animate({
                    scrollTop: 0
                }, 100);
            }
  }).children(".navigation__tier-3").click(function(e) {
    e.stopPropagation();
  });

  //tier 3 (dropdowns)
  $(".navigation .dropdown").on({
      click: function(e) {
        e.stopPropagation();
        if($(this).attr("data-opened") == "false") {
          $(this).attr("data-opened", "true");
        } else {
          $(this).attr("data-opened", "false");
        }
      }
  });
  //close menu btn
  $(".mobile-nav-toggle").on("click", function(e) {
      e.preventDefault();
      $(".mobile-menu").find(".navigation__tier-3").removeClass("toggled");
      $(".mobile-menu").find(".navigation__tier-2").removeClass("toggled");
      $(".mobile-menu").find(".navigation__tier-2").removeClass("no-footer");
      $(".mobile-menu").find(".dropdown").attr("data-opened", "false");
  })

  //go back btn
  $(".navigation__top-container div").on({
      click: function() {
        $(this).parent().parent().removeClass("toggled");
        $(".mobile-menu").find(".navigation__tier-2").removeClass("no-footer");
        $(".mobile-menu").find(".dropdown").attr("data-opened", "false");
      },
  })
}
